import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import DyteText from './DyteText';
import { defaultIconPack, IconPack } from '../lib/icons';

import { States } from '../types/props';
import { DyteI18n, useLanguage } from '../lib/lang';
import { SvgXml } from 'react-native-svg';
import { canViewChat } from '../utils/permissions';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  size,
  states,
  variant,
  iconPack,
  t,
}: {
  meeting: DyteClient;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  states?: States;
  variant?: 'button' | 'horizontal';
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  states = states ?? storeStates;
  let buttonSize = 25;
  let isHorizontal = true;
  switch (variant) {
    case 'button':
      isHorizontal = false;
      break;
  }
  switch (size) {
    case 'sm':
      buttonSize = 25;
      break;
    case 'lg':
      buttonSize = 50;
      break;
    case 'xl':
      buttonSize = 150;
      break;
  }

  const styles = StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: -2,
    },
    toggleContainer: {
      height: buttonSize * 2.1,
      width: '100%',
      backgroundColor: colors.background[1000],
    },
    horizontalStyle: {
      flexDirection: 'row',
      width: '100%',
      paddingVertical: 12,
      paddingLeft: 48,
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    textStyle: {
      paddingHorizontal: 18,
      color: colors.text,
    },
  });

  if (!canViewChat(meeting)) return null;

  return (
    <View style={styles.container}>
      <TouchableHighlight
        underlayColor={colors.background[800]}
        onPress={() => {
          setStates({
            ...states,
            activeSidebar: true,
            activeMoreMenu: false,
            sidebar: 'chat',
          });
        }}
        style={styles.toggleContainer}
      >
        {isHorizontal ? (
          <View style={styles.horizontalStyle}>
            <SvgXml
              xml={iconPack.chat.replace('currentColor', colors.text)}
              width={buttonSize}
              height={buttonSize}
            />
            <DyteText style={styles.textStyle}>{t('chat')}</DyteText>
          </View>
        ) : (
          <View style={styles.horizontalStyle}>
            <SvgXml
              xml={iconPack.chat.replace('currentColor', colors.text)}
              width={buttonSize}
              height={buttonSize}
            />
          </View>
        )}
      </TouchableHighlight>
    </View>
  );
}
